import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type BulkUpdateQuoteRequestLineQuantity = ClientInferResponseBody<
  typeof contract.quoteRequestLines.bulkUpdateQuantity
>;

export type BulkUpdateQuoteRequestLineQuantityDto = ClientInferRequest<
  typeof contract.quoteRequestLines.bulkUpdateQuantity
>["body"];

export const bulkUpdateQuoteRequestLineQuantity = async (
  payload: BulkUpdateQuoteRequestLineQuantityDto,
): Promise<BulkUpdateQuoteRequestLineQuantity> => {
  const response = await api.quoteRequestLines.bulkUpdateQuantity.mutation({
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to bulk update quantity", response.status, response.body);
};
